import { createAction } from '@ngrx/store';

export const AnimationActions = {
    SHOW_ANIMATION: '[ANIMATION] show',
    HIDE_ANIMATION: '[ANIMATION] hide',
}
export const ShowLoadAnimation = createAction(
    AnimationActions.SHOW_ANIMATION
);

export const HideLoadAnimation = createAction(
    AnimationActions.HIDE_ANIMATION
)